import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=30bba93c&"
import script from "./TabComponent.vue?vue&type=script&lang=js&"
export * from "./TabComponent.vue?vue&type=script&lang=js&"
import style0 from "./TabComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports